/**
 * Application Routes
 */
export const ROUTES = {
    // Auth
    login: '/auth/login',
    register: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    verifyEmail: '/auth/verify-email',
    changePassword: '/auth/change-password',

    // Core
    main: '/',
    home: '/home',
    profile: '/profile',

    // MMMS
    dashboard: '/dashboard', // Kept for backward compatibility
    weeklyReport: '/weekly-report',
    weeklyReportEdit: '/weekly-report/:id',
    weeklyReportView: '/weekly-report/:id/view',
    technicalAssessment: '/technical-assessment',
    technicalAssessmentEdit: '/technical-assessment/:id',
    technicalAssessmentView: '/technical-assessment/:id/view',
    partsRequisition: '/parts-requisition',
    partsRequisitionEdit: '/parts-requisition/:id',
    partsRequisitionView: '/parts-requisition/:id/view',
    reportsLibrary: '/reports-library',

    // Fallback
    notFound: '/404'
} as const;

/**
 * API Routes
 */
export const API_ROUTES = {
    // Auth
    login: '/auth/login/',
    logout: '/auth/logout/',
    signup: '/auth/registration/',
    confirmEmail: '/auth/registration/account-confirm-email/',
    resendEmail: '/resend-email-confirmation/',
    refresh: '/auth/refresh-token/',
    changePassword: '/auth/change-password/',
    forgotPassword: '/auth/forgot-password/',
    resetPassword: '/auth/reset-password/',
    resetPasswordConfirm: '/auth/reset-password-confirm/',

    // Core
    profile: '/users/me/',

    // Equipment
    equipment: '/equipment/equipment/',
    equipmentDetail: (id: number | string) => `/equipment/equipment/${id}/`,
    equipmentCategories: '/equipment/equipment/categories/',

    // Reports
    weeklyReports: '/reports/weekly-reports/',
    weeklyReportDetail: (id: number | string) => `/reports/weekly-reports/${id}/`,

    technicalAssessments: '/reports/technical-assessments/',
    technicalAssessmentDetail: (id: number | string) => `/reports/technical-assessments/${id}/`,

    partsRequisitions: '/reports/parts-requisitions/',
    partsRequisitionDetail: (id: number | string) => `/reports/parts-requisitions/${id}/`,
    parts: '/equipment/parts/',
} as const;

/**
 * Routes that do not require authentication
 */
export const NO_AUTH_REQUIRED_API_ROUTES: string[] = [
    API_ROUTES.login,
    API_ROUTES.signup,
    API_ROUTES.confirmEmail,
    API_ROUTES.resendEmail,
    API_ROUTES.forgotPassword,
    API_ROUTES.resetPassword,
    API_ROUTES.resetPasswordConfirm,
];
